// extracted by mini-css-extract-plugin
export default {"button":"SearchButton_button__++qSu","button--opened":"SearchButton_button--opened__FUN3q"};